import { render, staticRenderFns } from "./ReceiveApiModal.vue?vue&type=template&id=95298506&scoped=true"
import script from "./ReceiveApiModal.vue?vue&type=script&lang=js"
export * from "./ReceiveApiModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveApiModal.vue?vue&type=style&index=0&id=95298506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95298506",
  null
  
)

export default component.exports